"use client"

import * as React from "react"
import {
    ColumnDef,
} from "@tanstack/react-table";

import { usePermissions } from "react-admin";
import BookTour from "./BookTour";
import TourDetails from "./TourDetails";
import TourCreate from "./Create";
import CommonList from "@/components/common/List";
import CommonTableList from "@/components/common/TableList";
import { Tour } from "@/interface/entityInterface";
import { tableCol } from "@/components/common/columns/columns";
import { handleRowClick } from "@/utils/functions";

const ToursList = () => {

    const { permissions } = usePermissions();

    const [selectedTour, setSelectedTour] = React.useState<any | null>(null);
    const [isSheetOpen, setIsSheetOpen] = React.useState(false);

    const columns: ColumnDef<Tour>[] = tableCol({
        showActions: permissions && permissions?.user_role === "owner" ? true : false,
        columns: [
                {
            accessorKey: "photos",
            header: "Photos",
            cell: ({ row }: any) => {
                return (
                    <div className="gap-2">
                        <div className="flex gap-2">
                            {row.original.images && row.original.images.length > 0 ? (
                                row.original.images.map((i: any, index: number) => (
                                    <div
                                        key={index}
                                        className="w-[40px] h-[40px] aspect-square border rounded-md bg-transparent-100 flex items-center justify-center overflow-hidden"
                                    >
                                        {i?.imageUrl ? (
                                            <img
                                                src={i.imageUrl}
                                                alt={`Preview ${index + 1}`}
                                                className="w-[40px] h-[40px] object-cover"
                                                onError={(e) => {
                                                    (e.target as HTMLImageElement).style.display = 'none';
                                                }}
                                            />
                                        ) : (
                                            <span className="text-gray-400 text-[5px]">No image</span>
                                        )}
                                    </div>
                                ))
                            ) : (
                                <div className="flex gap-2">
                                    {[0, 1, 2, 3].map((i: any, index: number) => (
                                        <div
                                            key={index}
                                            className="w-[40px] h-[40px] aspect-square border rounded-md bg-transparent-100 flex items-center justify-center overflow-hidden"
                                        >
                                            {i?.imageUrl ? (
                                                <img
                                                    src={i.imageUrl}
                                                    alt={`Preview ${index + 1}`}
                                                    className="w-[40px] h-[40px] object-cover"
                                                    onError={(e) => {
                                                        (e.target as HTMLImageElement).style.display = 'none';
                                                    }}
                                                />
                                            ) : (
                                                <span className="text-gray-400 text-[5px]">No image</span>
                                            )}
                                        </div>
                                    ))}
                                </div>
                            )}
                        </div>
                    </div>
                );
            },
        },
        {
            accessorKey: "name",
            header: "Name",
            cell: ({ row }) => {
                return (
                    <div className="flex flex-col text-sm space-y-1">
                        <span className="font-medium">{row.getValue("name")}</span>
                    </div>
                );
            },
        },
        {
            accessorKey: "duration",
            header: "Duration",
            cell: ({ row }) => {
                return (
                    <div className="flex flex-col text-sm space-y-1">
                        <span className="font-medium">{row.getValue("duration")}</span>
                    </div>
                );
            },
        },
        ...(permissions && permissions?.user_role === "owner"
            ? [{
                accessorKey: "max_group_size",
                header: "Max Group Size",
                cell: ({ row }: any) => {
                    return (
                        <div className="flex flex-col text-sm space-y-1">
                            <span className="font-medium">{row.getValue("max_group_size")} people</span>
                        </div>
                    );
                },
            }]
            : []),
        {
            accessorKey: "tour_type",
            header: "Tour Type",
            cell: ({ row }) => {
                return (
                    <div className="flex flex-col text-sm space-y-1">
                        <span className="font-medium">{row.getValue("tour_type")}</span>
                    </div>
                );
            },
        },
        ...(permissions && permissions?.user_role === "commission_partner"
            ? [{
                accessorKey: "book",
                header: "Book Tour",
                cell: ({ row }: any) => (
                    <BookTour
                        key={row.id}
                        data={row.original}
                        title="Book Now"
                        description="Complete the form below to reserve your spot for this tour."
                    />
                )
            }]
            : []),
        ],
        resource: "tours",
    })

    return (
        <>
            <CommonList>
                <CommonTableList columns={columns} filterSearch="name" 
                    create={permissions && permissions.user_role == "owner" ? <TourCreate /> : <></>} 
                    rowClick={(row: Tour) => handleRowClick(row, setSelectedTour, setIsSheetOpen)}
                />
            </CommonList>
            {selectedTour && (
                <TourDetails selectedTour={selectedTour} isSheetOpen={isSheetOpen} setIsSheetOpen={setIsSheetOpen} />
            )}
        </>
    )
}

export default ToursList;